module.exports = __webpack_public_path__ + "static/media/hilda.4752af2a.png";